module.exports = __webpack_public_path__ + "static/media/ibia.3d5ed67e.svg";